import 'lazysizes';
import 'picturefill'
import 'picturefill/dist/plugins/mutation/pf.mutation.min'

import Glide from '@glidejs/glide'
// import serialize from 'form-serialize'


import GoogleMaps from './initGoogleMaps';


class ConstructionCity {
  constructor() {

    this.siteHeader = document.querySelector('.site-header')
    this.toggleMenuButton = document.querySelector('.site-header__toggle-menu-button')
    this.mobileMenuContainer = document.querySelector('.site-header__mobile-navigation')
    this.prevScrollPosition = 0;

    this.scrollHandler = this.scrollHandler.bind(this);

    GoogleMaps();

  }

  scrollHandler(e) {

    if (document.body.classList.contains('menu-is-open')) {
      return
    }

    let newPosition = window.scrollY,
      offset = 50;

    if (newPosition > offset) {
      this.siteHeader.classList.add('site-header--solid');
      if (newPosition > this.prevScrollPosition + 25) {
        this.siteHeader.classList.add('site-header--hidden');
      }
      if (newPosition < this.prevScrollPosition - 25) {
        this.siteHeader.classList.remove('site-header--hidden');
      }
    } else {
      this.siteHeader.classList.remove('site-header--solid', 'site-header--hidden');
    }
    this.prevScrollPosition = newPosition;

  }


  duplicateInputs() {

    const inputs = document.querySelectorAll('input.duplicate-input-field');
    inputs.forEach(input => {

      const duplicateField = document.querySelector(`#${ input.dataset.duplicate }`)
      if (duplicateField) {
        input.addEventListener('input', event => {
          duplicateField.value = input.value
        })
      }

    })

  }


  init() {

    // this.scrollHandler();
    window.addEventListener('scroll', this.scrollHandler)

    this.toggleMenuButton.addEventListener('click', e => {

      if (document.body.classList.contains('menu-is-open')) {
        this.toggleMenuButton.setAttribute('aria-expanded', false);
        document.body.classList.remove('menu-is-open')
      } else {
        this.toggleMenuButton.setAttribute('aria-expanded', true);
        document.body.classList.add('menu-is-open')
      }

    })


    const glideElement = document.querySelector('.featured-members__list-wrapper')
    if (glideElement) {

      new Glide('.featured-members__list-wrapper', {
        type: 'carousel',
        startAt: 0,
        autoplay: 2500,
        perView: 5,
        gap: 60,
        breakpoints: {
          1280: {
            perView: 4,
            gap: 40,
          },
          1024: {
            perView: 3,
            gap: 30,
          }
        }
      }).mount()

    }


    this.duplicateInputs();


  }

}

const site = new ConstructionCity();
site.init();


const employees = document.querySelectorAll('.employees__item')

if (employees) {
  let maxHeight = 0
  employees.forEach(employee => {
    if (employee.offsetHeight > maxHeight) maxHeight = employee.offsetHeight
  })
  employees.forEach(employee => {
    employee.style.minHeight = maxHeight + 'px'
  })
}